/** 空的 space id 不能当 org 主键 */
export function isMockSpaceId(id: string | null | undefined): boolean {
  return !id?.trim()
}

/**
 * 所属空间 / X-Org-Id 用的 space_id。
 * 有值则原样用，空则 undefined（由调用方决定是否再回落）。
 */
export function resolveOwnerSpaceId(
  candidate?: string | null,
): string | undefined {
  const id = candidate?.trim()
  return id || undefined
}

/** @deprecated 使用 resolveOwnerSpaceId */
export function resolveOrgId(spaceId?: string | null): string | undefined {
  return resolveOwnerSpaceId(spaceId)
}
